<template>
  <div style="background-color: #F8F9FB;">
    <hhead></hhead>
    <crm-nav></crm-nav>
    <div class="jgMsg_box">
      <div
        class="jgMsg"
        :style="{
          minHeight: MHeight,
          boxSizing: 'border-box',
          minWidth: '1000px',
        }"
      >
        <div class="fxTop" :style="{ display: display }">
          <div class="left">
            <h2>拟合分析</h2>
            <!-- <div class="prev" @click="prev">
              <i class="iconfont icon-chehui"></i> &nbsp;点击返回
            </div> -->
            <div class="date">
              <span>选择时间段： </span>
              <div class="block">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  value-format="yyyy/MM/dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
              <span class="btn1" @click="seeBtn">查看</span>
              <!-- <span class="btn1">导出</span> -->
            </div>
          </div>
          <div class="right">
            <div>
              <b>累计收益</b>
              <p
                :style="{
                  color: tabL.yearlyProfitRate >= 0 ? '#FA4B22' : '#44C786',
                }"
              >
                {{ tabL.profitRate | sum4 }} <i>%</i>
              </p>
            </div>
            <span></span>
            <div>
              <b>最大回撤</b>
              <p :style="{ color: '#44C786' }">
                {{ tabL.maxLoss | sum4 }} <i>%</i>
              </p>
            </div>
            <span></span>
            <div>
              <b>夏普比率</b>
              <p :style="{ color: '#5B85FF' }">{{ tabL.sharpeRate | sum2 }}</p>
            </div>
            <span></span>
            <div>
              <b>卡玛比率</b>
              <p :style="{ color: '#5B85FF' }">{{ tabL.calmarRate | sum2 }}</p>
            </div>
          </div>
        </div>

        <div class="content_">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="拟合分析" name="1">
              <el-row :gutter="10">
                <el-col :lg="24" :xl="8">
                  <div class="boxMsg">
                    <div class="top top1">
                      收益
                      <span class="iconfont icon-question">
                        <p class="title__">
                          当前收益：统计周期内的绝对收益率；<br />
                          年化收益：统计期内的年化收益率（一
                          般结合账户操作时间与回撤指标来综合 考量）；<br />
                          单日最大盈利：统计期内，单个交易日
                          的最大盈利（一般结合单日最大回撤与
                          该投顾的策略来综合考量）；<br />
                          夏普比率：统计周期内的夏普比率，账
                          户风险调整后收益水平以及账户波动率
                          的综合参考指标（目的是计算投资组合
                          每承受一单位总风险，会产生多少的超 额报酬）；<br />
                          索提诺比率：统计周期内的索提诺比率，
                          与夏普比率类似，区别在于索提诺比率
                          更注重相同下行风险的波动率（和夏普
                          比率类似，这一比率越高，表明基金承
                          担相同单位下行风险能获得更高的超额 回报率）。
                        </p>
                      </span>
                    </div>
                    <div class="bottom1" style="color: #F05050;">
                      <div class="bottomT">
                        <div>
                          <span>当前收益</span>
                          <p>{{ tabL.profitRate | sum }}</p>
                        </div>
                        <div>
                          <span>单日最大盈利</span>
                          <p>{{ tabL.maxDailyProfit | sum }}</p>
                        </div>
                        <div>
                          <span>年化收益</span>
                          <p>{{ tabL.yearlyProfitRate | sum }}</p>
                        </div>
                      </div>
                      <div class="bottomB">
                        <div>
                          <span>夏普比率</span>
                          <p>{{ tabL.sharpeRate | sum2 }}</p>
                        </div>
                        <div>
                          <span>索提诺比率</span>
                          <p>{{ tabL.sortinoRate | sum2 }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :lg="24" :xl="8">
                  <div class="boxMsg">
                    <div class="top top2">
                      回撤
                      <span class="iconfont icon-question">
                        <p style="color: #44c786" class="title__">
                          <b>峰值回撤（率）</b
                          >：统计周期内，较前一净值高点的最大回撤比率；<br /><b
                            >本金回撤（率）</b
                          >：统计周期内，期末权益小于账户初始本金的最大回撤金额占初始本金（包含净出入金）的比率（一般作为风险控制方面的参考指标）；<br /><b
                            >单日最大亏损</b
                          >：统计周期内，单个交易日最大亏损；<br /><b
                            >最大连续回撤天数</b
                          >：统计周期内，最大的连续回撤天数；<br /><b
                            >最大回撤修复天数</b
                          >：统计周期内，从前一个净值高点到下一个净值创新高的最大交易天数。
                        </p>
                      </span>
                    </div>
                    <div class="bottom2" style="color: #44C786;">
                      <div class="bottomT">
                        <div>
                          <span>最大回撤</span>
                          <p>{{ tabL.maxLoss | sum }}</p>
                        </div>
                        <div>
                          <span>本金回撤</span>
                          <p>{{ tabL.capitalLoss | sum }}</p>
                        </div>
                        <div>
                          <span>单日最大回撤</span>
                          <p>{{ tabL.maxDailyLosss | sum }}</p>
                        </div>
                      </div>
                      <div class="bottomB">
                        <div>
                          <span>最大连续回撤天数</span>
                          <p>{{ tabL.maxLossContinueTradingDayCount }}</p>
                        </div>
                        <div>
                          <span>最大回撤修复天数</span>
                          <p>{{ tabL.maxLossRepartTradingDayCount }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :lg="24" :xl="8">
                  <div class="boxMsg">
                    <div class="top top3">
                      其他
                      <span class="iconfont icon-question">
                        <p style="color: #3891ec" class="title__">
                          <b>卡玛比率（收益风险比率）</b
                          >：统计周期内，其绝对收益与最大回撤的比率；<br /><b
                            >年化波动率：</b
                          >：统计周期内，年化最高收益与最低收益的波动比率；<br /><b
                            >年化下行波动率</b
                          >：统计周期内，回撤期间的年化波动比率；<br /><b
                            >历史最大净值</b
                          >：数据统计期内的最高净值；<br /><b>重仓失效率</b
                          >：统计周期内，重仓操作后的回撤比率（一般作为资金管理能力的参考指标）。
                        </p>
                      </span>
                    </div>
                    <div class="bottom3" style="color: #3891EC;">
                      <div class="bottomT">
                        <div>
                          <span>卡玛比率</span>
                          <p>{{ tabL.calmarRate | sum2 }}</p>
                        </div>
                        <div>
                          <span>年化波动率</span>
                          <p>{{ tabL.yearlyWave | sum }}</p>
                        </div>
                        <div>
                          <span>年化下行波动率</span>
                          <p>{{ tabL.yearlyDownWave | sum }}</p>
                        </div>
                      </div>
                      <div class="bottomB">
                        <div>
                          <span>历史最大净值</span>
                          <p>{{ tabL.maxNetValue | sum1 }}</p>
                        </div>
                        <div>
                          <span>重仓失效</span>
                          <p>{{ tabL.positionFailRate | sum }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="echartsBox">
                <div class="main">
                  <div id="main001" style="height: 550px;"></div>
                </div>
              </div>

              <div class="echartsBox">
                <div class="main">
                  <div id="main002" style="height: 550px;"></div>
                </div>
              </div>

              <div class="echartsBox">
                <div class="main">
                  <div id="main003" style="height: 550px;"></div>
                </div>
              </div>

              <div class="echartsBox">
                <div class="main">
                  <div id="main004" style="height: 550px;"></div>
                </div>
              </div>

              <div class="table tableRels">
                <table class="" style="width: 100%;" border="1">
                  <thead class="has-gutter">
                    <th>账户</th>
                    <th>姓名</th>
                    <th>净值</th>
                    <th>累计收益</th>
                    <th>最大回撤</th>
                    <th>夏普比率</th>
                    <th>卡玛比率</th>
                    <th>年化收益</th>
                    <th>索提诺比例</th>
                    <th>收益风险比</th>
                    <th>年化波动</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in tableList" :key="index">
                      <td style="text-align: center;">{{ item.userCode }}</td>
                      <td style="text-align: center;">{{ item.userName }}</td>

                      <!-- 净值 -->
                      <td
                        :style="{
                          textAlign: 'right',
                          color: item.profitRate >= 0 ? '#FA5D22' : '#3ABA94',
                        }"
                      >
                        {{ item.profitRate | sum1 }}
                      </td>
                      <!-- 累计收益 -->
                      <td
                        :style="{
                          textAlign: 'right',
                          color: item.profitRate >= 0 ? '#FA5D22' : '#3ABA94',
                        }"
                      >
                        {{ item.profitRate | sum }}
                      </td>

                      <!-- 最大回撤 -->
                      <td :style="{ textAlign: 'right', color: '#3ABA94' }">
                        {{ item.maxLoss | sum }}
                      </td>
                      <!-- 夏普比率 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ item.sharpeRate | sum2 }}
                      </td>
                      <!-- 卡玛比率 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ item.calmarRate | sum2 }}
                      </td>
                      <!-- 年化收益 -->
                      <td
                        :style="{
                          textAlign: 'right',
                          color:
                            item.yearlyProfitRate >= 0 ? '#FA5D22' : '#3ABA94',
                        }"
                      >
                        {{ item.yearlyProfitRate | sum }}
                      </td>
                      <!-- 索提诺比例 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ item.sortinoRate | sum2 }}
                      </td>
                      <!-- 收益风险比 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ item.profitRiskCp | sum2 }}
                      </td>
                      <!-- 年化波动 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ item.yearlyWave | sum }}
                      </td>
                    </tr>
                    <tr>
                      <td style="text-align: center;">拟合汇总</td>
                      <td>&nbsp;</td>
                      <!-- 净值 -->
                      <td
                        :style="{
                          textAlign: 'right',
                          color: tabL.profitRate >= 0 ? '#FA5D22' : '#3ABA94',
                        }"
                      >
                        {{ tabL.profitRate | sum1 }}
                      </td>
                      <!-- 累计收益 -->
                      <td
                        :style="{
                          textAlign: 'right',
                          color: tabL.profitRate >= 0 ? '#FA5D22' : '#3ABA94',
                        }"
                      >
                        {{ tabL.profitRate | sum }}
                      </td>
                      <!-- 最大回撤 -->
                      <td :style="{ textAlign: 'right', color: '#3ABA94' }">
                        {{ tabL.maxLoss | sum }}
                      </td>
                      <!-- 夏普比率 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ tabL.sharpeRate | sum2 }}
                      </td>
                      <!-- 卡玛比率 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ tabL.calmarRate | sum2 }}
                      </td>

                      <!-- 年化收益 -->
                      <td
                        :style="{
                          textAlign: 'right',
                          color:
                            tabL.yearlyProfitRate >= 0 ? '#FA5D22' : '#3ABA94',
                        }"
                      >
                        {{ tabL.yearlyProfitRate | sum }}
                      </td>
                      <!-- 索提诺比例 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ tabL.sortinoRate | sum2 }}
                      </td>
                      <!-- 收益风险比 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ tabL.profitRiskCp | sum2 }}
                      </td>
                      <!-- 年化波动 -->
                      <td :style="{ textAlign: 'right' }">
                        {{ tabL.yearlyWave | sum }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="相关性分析" name="2">
              <div class="echartsBox">
                <div class="main">
                  <div
                    id="main005"
                    :style="{ height: '550px', width: MWidth }"
                  ></div>
                </div>

                <h2>
                  说明：白色（50%以下） 黄色 （50%-80%）红色（80%-100%）
                </h2>
                <div class="table tableRels">
                  <table class="" style="width: 100%;" border="1">
                    <thead class="has-gutter">
                      <th>&nbsp;</th>
                      <th v-for="(item, index) in tableList" :key="index">
                        {{ item.userName }}
                      </th>
                    </thead>
                    <tbody>
                      <tr v-for="item in tableList" :key="item.userCode">
                        <td>{{ item.userName }}</td>
                        <td
                          :style="{
                            textAlign: 'right',
                            background:
                              option.rels[e.userCode + '_' + item.userCode] >=
                              1.0
                                ? ''
                                : option.rels[
                                    e.userCode + '_' + item.userCode
                                  ] >= 0.8
                                ? '#ff665a'
                                : option.rels[
                                    e.userCode + '_' + item.userCode
                                  ] >= 0.5
                                ? '#ffc05c'
                                : '',
                          }"
                          v-for="(e, i) in tableList"
                          :key="i"
                          :title="e.userName + '、' + item.userName"
                        >
                          {{
                            e.userCode != item.userCode
                              ? option.rels[e.userCode + '_' + item.userCode]
                              : '/' | num
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from '../../header/index';
import crmNav from '../../../../components/crmNav/index';
import './style.css';
const echarts = require('echarts');
var myCharts;
export default {
  components: { hhead, crmNav },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 94 + 'px',
      MWidth: '',
      userName: '',
      tabL: '',
      tableList: [],
      option: {},
      colorArray: [
        '#ec0000',
        '#732acb',
        '#00d4de',
        '#FF7F00',
        '#3f769e',
        '#cda1ac',
        '#4f00a3',
        '#f5b868',
        '#5a8fea',
        '#FFD700',
        '#a06375',
        '#ca0073',
        '#a75602',
        '#000000',
        '#dea195',
        '#732acb',
        '#0000ba',
        '#a7cdc9',
        '#df829a',
        '#8E388E',
        '#ff00ff',
      ],
      shortcuts: [
        {
          text: '最近一周',
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          })(),
        },
        {
          text: '最近一个月',
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          })(),
        },
        {
          text: '最近三个月',
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          })(),
        },
      ],
      value1: '',
      activeName: '1',
      display: 'flex',
    };
  },

  filters: {
    num: function(n) {
      if (n && n != '/') {
        return (Math.round(n * 10000) / 100).toFixed(2) + '%';
      } else if (n == '/') {
        return '/';
      } else {
        return '';
      }
    },
    sum: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2) + '%';
      } else {
        return '0.00%';
      }
    },
    sum1: function(n) {
      if (n) {
        return (n + 1).toFixed(4);
      } else {
        return '0.0000';
      }
    },
    sum2: function(n) {
      if (n) {
        return (Math.round(n  * 100) / 100).toFixed(2);
      } else {
        return '0.00';
      }
    },
    sum4: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2);
      } else {
        return '0.00';
      }
    },
  },

  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    window.onresize = () => {
      return (() => {
        if (document.documentElement.clientWidth < 1600) {
          this.display = 'block';
        } else {
          this.display = 'flex';
        }
      })();
    };

    this.MWidth =
      document.getElementsByClassName('jgMsg')[0].clientWidth + 'px';
    // console.log(this.MWidth);
    this.pageAxios();
  },
  methods: {
    seeBtn() {
      //查看
      //   console.log(this.value1);
      if (this.value1) {
        this.$axios
          .post('/crm/acc_date/eval', {
            apiToken: this.$store.state.usermsg.apiToken,
            type: this.$route.query.id
              ? 0
              : this.$route.query.InvestorId
              ? 2
              : this.$route.query.contractId
              ? 1
              : '',
            accIds: this.$route.query.id ? this.$route.query.id : '',
            invId: this.$route.query.InvestorId
              ? this.$route.query.InvestorId
              : '',
            conId: this.$route.query.contractId
              ? this.$route.query.contractId
              : '',
            startTime: this.value1 ? this.value1[0] : '',
            entTime: this.value1 ? this.value1[1] : '',
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.option = res.data.data;
              this.tableList = res.data.data.multiAcc.evals;
              this.tabL = res.data.data.multiAcc.sumEval;
              this.worth();
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          })
          .catch((err) => {
            this.$alert('暂无数据', {
              confirmButtonText: '确定',
              type: 'error',
              center: true,
            })
              .then(() => {})
              .catch(() => {});
          });
      } else {
        this.$alert('请选择日期', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    pageAxios() {
      this.$axios
        .post('/crm/acc_date/eval', {
          apiToken: this.$store.state.usermsg.apiToken,
          type: this.$route.query.id
            ? 0
            : this.$route.query.InvestorId
            ? 2
            : this.$route.query.contractId
            ? 1
            : '',
          accIds: this.$route.query.id ? this.$route.query.id : '',
          invId: this.$route.query.InvestorId
            ? this.$route.query.InvestorId
            : '',
          conId: this.$route.query.contractId
            ? this.$route.query.contractId
            : '',
        })
        .then((res) => {
          //   console.log(res);
          if (res.data.code == 200) {
            let name = '';
            res.data.data.relNames.forEach((item) => {
              name += ',' + item;
            });
            this.userName = name.replace('，', '');
            this.option = res.data.data;
            this.tableList = res.data.data.multiAcc.evals;
            this.tabL = res.data.data.multiAcc.sumEval;
            this.value1 = [this.tabL.beginDate, this.tabL.endDate];
            this.worth();
          }
        });
    },
    // getSummaries(param) {
    //   const { columns, data } = param;
    //   const sums = [];
    //   sums[0] = '拟合汇总';
    //   sums[2] = (
    //     Math.round((this.option.multiAcc.sumEval.profitRate + 1) * 10000) /
    //     10000
    //   ).toFixed(4);
    //   sums[3] = this.option.multiAcc.sumEval.yearlyProfitRate;
    //   sums[4] = this.option.multiAcc.sumEval.maxLoss;
    //   sums[5] = this.option.multiAcc.sumEval.sharpeRate;
    //   sums[6] = this.option.multiAcc.sumEval.sortinoRate;
    //   sums[7] = this.option.multiAcc.sumEval.profitRiskCp;
    //   sums[8] = this.option.multiAcc.sumEval.yearlyWave;
    //   return sums;
    // },
    prev() {
      this.$router.go(-1);
    },
    handleClick() {
      if (this.activeName == '2') {
        this.cylinder();
      }
      //   console.log(this.activeName);
    },
    cylinder() {
      var option4 = {
        title: {
          text: '相关性排行（前20）' /*当日盈亏与手续费*/,
          textStyle: {
            fontWeight: 'normal',
          },
        },
        // graphic: graphic,
        toolbox: {
          feature: {
            saveAsImage: { show: window.innerWidth > 500 },
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '5%',
          bottom: 100,
          containLabel: false,
        },
        legend: {
          data: ['相关性'],
          right: 60,
        },
        xAxis: {
          type: 'category',
          axisLabel: { interval: 0 },
          data: this.option.relNames,
        },
        yAxis: [
          {
            name: '',
            type: 'value',
            position: 'right',
          },
        ],
        color: ['#FA5D22', '#5599FF'],
        series: [
          {
            name: '相关性',
            type: 'bar',
            barMaxWidth: 30,
            barGap: 0,
            itemStyle: {
              normal: {
                color: function(o) {
                  if (o.value >= 0) {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#FF0033',
                      },
                      {
                        offset: 1,
                        color: '#FF6666',
                      },
                    ]);
                  } else {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#66CC99',
                      },
                      {
                        offset: 1,
                        color: '#339933',
                      },
                    ]);
                  }
                },
              },
            },
            data: this.option.relValues,
          },
        ],
      };

      var chartDom5 = document.getElementById('main005');
      var myChart5 = echarts.init(chartDom5);
      myChart5.setOption(option4);
    },
    worth() {
      //   console.log(this.option);
      var NAME1 = this.option.multiAcc.netValueUserNames;
      var NAME2 = this.option.multiAcc.hcValueUserNames;
      var NAME3 = this.option.multiAcc.dayValueUserNames;
      var TIMES = this.option.multiAcc.times;
      var DATA = this.option.multiAcc.netValueArray;
      var HC_DATA = this.option.multiAcc.hcArray;
      var DAY_DATA = this.option.multiAcc.netDailyProfitArray;
      var seriesArray = new Array();
      var hcArray = new Array();
      var waveArray = new Array();
      var HC_AVG_ARRAY =
        this.option.multiAcc.sumEval == null
          ? '[]'
          : this.option.multiAcc.sumEval.hisLossArray;
      var WAVE_AVG_ARRAY =
        this.option.multiAcc.sumEval == null
          ? '[]'
          : this.option.multiAcc.sumEval.netDailyProfitArray;

      //净值;
      for (var i = 0; i < NAME1.length; i++) {
        var dataList = new Array();
        for (var x = 0; x < DATA[i].length; x++) {
          dataList.push(DATA[i][x] == '-' ? DATA[i][x] : DATA[i][x].toFixed(4));
        }
        var jsonObj = {
          name: NAME1[i],
          type: 'line',
          // stack: '净值',
          data: dataList,
          symbol: 'none',
        };
        if (i == 0) {
          jsonObj.lineStyle = {
            normal: {
              width: 4,
              shadowColor: 'rgba(0,0,0,0.6)',
              shadowBlur: 10,
              shadowOffsetY: 12,
            },
          };
        }
        seriesArray.push(jsonObj);
      }

      //回撤
      //拟合线
      for (var i = 0; i < NAME2.length; i++) {
        var dataList = new Array();
        if (i == 0) {
          for (var x = 0; x < HC_AVG_ARRAY.length; x++) {
            dataList.push(
              HC_AVG_ARRAY[x] == '-' ? HC_AVG_ARRAY[x] : HC_AVG_ARRAY[x]
            );
          }
        } else {
          for (var x = 0; x < HC_DATA[i].length; x++) {
            dataList.push(
              HC_DATA[i][x] == '-'
                ? HC_DATA[i][x]
                : parseFloat(HC_DATA[i][x]).toFixed(2)
            );
          }
        }
        var jsonObj = {
          name: NAME2[i],
          type: 'line',
          // stack: '净值',
          data: dataList,
          symbol: 'none',
        };
        if (i == 0) {
          jsonObj.lineStyle = {
            normal: {
              width: 4,
              shadowColor: 'rgba(0,0,0,0.6)',
              shadowBlur: 10,
              shadowOffsetY: 12,
            },
          };
        }
        hcArray.push(jsonObj);
      }

      //回撤
      //拟合线
      for (var i = 0; i < NAME3.length; i++) {
        var dataList = new Array();
        if (i == 0) {
          for (var x = 0; x < WAVE_AVG_ARRAY.length; x++) {
            dataList.push(
              WAVE_AVG_ARRAY[x] == '-' ? WAVE_AVG_ARRAY[x] : WAVE_AVG_ARRAY[x]
            );
          }
        } else {
          for (var x = 0; x < DAY_DATA[i].length; x++) {
            dataList.push(
              DAY_DATA[i][x] == '-'
                ? DAY_DATA[i][x]
                : parseFloat(DAY_DATA[i][x]).toFixed(2)
            );
          }
        }
        var jsonObj = {
          name: NAME3[i],
          type: 'line',
          // stack: '净值',
          data: dataList,
          symbol: 'none',
        };
        if (i == 0) {
          jsonObj.lineStyle = {
            normal: {
              width: 4,
              shadowColor: 'rgba(0,0,0,0.6)',
              shadowBlur: 10,
              shadowOffsetY: 12,
            },
          };
        }
        waveArray.push(jsonObj);
      }

      var graphic = {
        type: 'image',
        z: -10,
        position: 0,
        style: {
          image: '../../../../assets/images/crm/shuiyin.png',
          height: 450,
        },
      };

      var option0 = {
        title: {
          text: '拟合净值与回撤',
          textStyle: {
            fontWeight: 'normal',
          },
        },
        //   graphic: graphic,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        axisPointer: {
          link: { xAxisIndex: 'all' },
          label: {
            backgroundColor: '#777',
          },
        },
        grid: [
          {
            left: '5%',
            right: '5%',
            top: '10%',
            height: '60%',
            bottom: '5%',
            containLabel: false,
          },
          {
            left: '5%',
            right: '5%',
            top: '75%',
            height: '20%',
            bottom: 50,
            containLabel: false,
          },
        ],
        toolbox: {
          feature: {
            saveAsImage: { show: window.innerWidth > 500 },
          },
        },
        legend: {
          data: ['拟合净值', '拟合波动', '拟合回撤'],
          right: 30,
        },
        xAxis: [
          {
            type: 'category',
            axisPointer: {
              type: 'shadow',
            },
            data: this.option.multiAcc.sumEval.dateArray,
          },
          {
            type: 'category',
            axisPointer: {
              type: 'shadow',
            },
            data: this.option.multiAcc.sumEval.dateArray,
            gridIndex: 1,
          },
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            // min: 0,
            splitNumber: 6,
            axisLabel: {
              formatter: '{value} %',
            },
            splitArea: { show: false },
            splitLine: { show: false },
            boundaryGap: ['5%', '70%'],
          },
          {
            type: 'value',
            scale: true,
            // min: 0,
            // max: 25,
            splitNumber: 6,
            // axisLabel: {
            //     formatter: '{value} °C'
            // }
          },
          {
            type: 'value',
            scale: true,
            // min: 0,
            // max: 25,
            splitNumber: 2,
            axisLabel: {
              formatter: '{value} %',
            },
            gridIndex: 1,
            position: 'right',
          },
        ],
        color: ['#FA5D22', '#ad0404', '#5599FF'],
        series: [
          {
            name: '拟合净值',
            type: 'line',
            symbol: 'none',
            yAxisIndex: 1,
            lineStyle: {
              normal: {
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            tooltip: {
              formatter: '{a0}: {c0}',
            },
            data: seriesArray[0].data,
          },
          {
            name: '拟合波动',
            type: 'bar',
            barMaxWidth: 30,
            symbol: 'none',
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#f08c00' },
                  { offset: 0.5, color: '#f0d058' },
                  { offset: 1, color: '#f6e6ac' },
                ]),
              },
            },
            tooltip: {
              formatter: '{a0}: {c0}%',
            },
            data: this.option.multiAcc.sumEval.netDailyProfitArray,
          },
          {
            name: '拟合回撤',
            type: 'line',
            animation: false,
            xAxisIndex: 1,
            yAxisIndex: 2,
            gridIndex: 1,
            symbol: 'none',
            connectNulls: true,
            itemStyle: {
              normal: {
                color: function(o) {
                  return '#5599FF';
                },
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#5599FF' },
                  { offset: 1, color: '#FF5B4A' },
                ]),
              },
            },
            lineStyle: {
              width: 1,
            },
            tooltip: {
              formatter: '{a0}: {c0}%',
            },
            data: this.option.multiAcc.sumEval.hisLossArray,
          },
        ],
      };

      var option1 = {
        title: {
          text: '投顾净值',
          textStyle: {
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: NAME1,
          right: 30,
          top: 5,
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: 50,
          containLabel: false,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: TIMES,
        },
        yAxis: {
          type: 'value',
          scale: true,
          boundaryGap: ['10%', '10%'],
          position: 'right',
        },
        graphic: [
          {
            type: 'image',
            style: {
              backgroundColor: 'transparent',
              z: 100,
              position: 0,
              image: '',

              height: 550,
            },
          },
        ],
        series: seriesArray,
        color: this.colorArray,
      };

      var option2 = {
        title: {
          text: '投顾回撤',
          textStyle: {
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            var html = params[0].name + '<br>';
            for (var i = 0; i < params.length; i++) {
              html +=
                '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
                params[i].color +
                ';"></span>';
              var value = params[i].value;
              if (value != '-') {
                html += NAME2[i] + ':' + value + '%<br>';
              } else {
                html += NAME2[i] + ':' + value + '<br>';
              }
            }
            return html;
          },
        },
        legend: {
          data: NAME2,
          right: 30,
          top: 5,
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: 50,
          containLabel: false,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: TIMES,
        },
        yAxis: {
          type: 'value',
          scale: true,
          boundaryGap: ['10%', '10%'],
          axisLabel: {
            formatter: '{value} %',
          },
          position: 'right',
        },
        //   graphic: [
        //     {
        //       type: 'image',
        //       z: -10,
        //       position: 0,
        //       style: {
        //         image: '',
        //         height: 450,
        //       },
        //     },
        //   ],
        series: hcArray,
        color: this.colorArray,
      };

      var option3 = {
        title: {
          text: '投顾净值波动',
          textStyle: {
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            var html = params[0].name + '<br>';
            for (var i = 0; i < params.length; i++) {
              html +=
                '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
                params[i].color +
                ';"></span>';
              var value = params[i].value;
              if (value != '-') {
                html += NAME3[i] + ':' + value + '%<br>';
              } else {
                html += NAME3[i] + ':' + value + '<br>';
              }
            }
            return html;
          },
        },
        legend: {
          data: NAME3,
          right: 30,
          top: 5,
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: 50,
          containLabel: false,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: TIMES,
        },
        yAxis: {
          type: 'value',
          scale: true,
          boundaryGap: ['10%', '10%'],
          axisLabel: {
            formatter: '{value} %',
          },
          position: 'right',
        },
        //   graphic: [
        //     {
        //       type: 'image',
        //       z: -10,
        //       position: 0,
        //       style: {
        //         image: '',
        //         height: 450,
        //       },
        //     },
        //   ],
        series: waveArray,
        color: this.colorArray,
      };
      var chartDom = document.getElementById('main001');
      var chartDom2 = document.getElementById('main002');
      var chartDom3 = document.getElementById('main003');
      var chartDom4 = document.getElementById('main004');
      var myChart0 = echarts.init(chartDom);
      var myChart2 = echarts.init(chartDom2);
      var myChart3 = echarts.init(chartDom3);
      var myChart4 = echarts.init(chartDom4);
      myChart0.setOption(option0);
      myChart2.setOption(option1);
      myChart3.setOption(option2);
      myChart4.setOption(option3);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/analysis/Fitting/index.vue